<template>
    <div style="padding:20px; display:flex; justify-content: left;">
        <div style="width:300px; margin:20px">
            <DicItem title="泊位"></DicItem>
        </div>
        <div style="width:300px; margin:20px">
            <DicItem title="堆场"></DicItem>
        </div>
        <div style="width:300px; margin:20px">
            <DicItem title="类型"></DicItem>
        </div>
        <div style="width:300px; margin:20px">
            <DicItem title="码头设备"></DicItem>
        </div>
    </div>
</template>
<script>
import DicItem from './DicItem';
export default {
    components:{
        DicItem,
    }
}
</script>